import React from 'react';
import s from '../styles.scss';

export const Container: React.FunctionComponent = (props) => (
  <section className={s.container}>{props.children}</section>
);
Container.displayName = 'Container';
